import { render, staticRenderFns } from "./nlp-analysis.html?vue&type=template&id=3c7625b6&scoped=true&"
import script from "./nlp-analysis.js?vue&type=script&lang=js&"
export * from "./nlp-analysis.js?vue&type=script&lang=js&"
import style0 from "./nlp-analysis.scss?vue&type=style&index=0&id=3c7625b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7625b6",
  null
  
)

export default component.exports